<template>
  <div class="container_self">
    <el-row class="table_parent">
      <h3>Quiz列表</h3>
      <el-row class="add_btn"
        ><el-button type="success" icon="el-icon-plus" size="mini" @click="addVideo"
          >添加Quiz</el-button
        ></el-row
      >
      <el-row style="margin: 15px 0; font-size: 14px">
        <span class="label">域名</span>
        <el-select
          v-model="domain"
          placeholder="请选择域名"
          size="mini"
          clearable
          @change="domainChange"
        >
          <el-option
            v-for="(item, index) in domainList"
            :key="index"
            :label="item.dm"
            :value="item.dm"
          ></el-option>
        </el-select>

        <el-button
          type="danger"
          size="mini"
          style="margin: 0 5px 0 25px"
          @click="addMovieToDm"
          >批量加入域名</el-button
        >
        <!-- <el-button type="warning" size="mini" @click="removeMovieToDm">从域名批量删除</el-button> -->
      </el-row>
      <el-table
        :data="videoList"
        v-loading="loading"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column  width="55" prop="id" align="center" label="ID"></el-table-column>
        <el-table-column
          label="title"
          prop="title"
          align="center"
          width="400"
        ></el-table-column>
        <el-table-column label="quiz图片" width="300" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.image"
              placement="top"
            >
              <span class="table_span">{{ scope.row.image }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="分类" align="center">
          <template slot-scope="scope">
            <span>{{ getCategoryName(scope.row.categoryId) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="quiz概要" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.description"
              placement="top"
            >
              <span class="table_span">{{ scope.row.description }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="作者"
          prop="editor"
          align="center"
          width="120"
        ></el-table-column>
        <!-- <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column> -->
        <el-table-column label="操作" align="center" fixed="right" width="360">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="openAddQuestionDialog(scope.row)">添加内容</el-button>
            <el-button type="warning" size="mini" @click="openAddResultDialog(scope.row)">添加结果预设</el-button>
            <el-button type="primary" size="mini" @click="updateVideo(scope.row)">更新</el-button>
            <el-button type="danger" size="mini" @click="deleteQuiz(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="videoSearch.currentPage"
        :page-sizes="[50, 100, 200]"
        :page-size="videoSearch.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

      <el-dialog
        :title="title"
        :visible.sync="dialogFormVisible"
        top="3vh"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <el-form
          :model="addVideoForm"
          class="search_parent"
          size="mini"
          top="0"
          label-width="120px"
        >
          <el-form-item label="Quiz标题">
            <el-input
              v-model="addVideoForm.title"
              clearable
              placeholder="请输入Quiz标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="作者">
            <el-input
              v-model="addVideoForm.editor"
              clearable
              placeholder="请输入作者名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="Quiz概要">
            <el-input
              type="textarea"
              v-model="addVideoForm.description"
              clearable
              placeholder="请输入Quiz概要"
            ></el-input>
          </el-form-item>
          <el-form-item label="Quiz分类">
            <el-select v-model="addVideoForm.categoryId" @change="categoryChange">
              <el-option v-for="(item,index) in categoryList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传封面">
            <el-upload
              drag
              action="https://adminapi.ci-ads.com/api/movie/upload/file"
              style="display: inline-block; margin-left: 15px"
              class="upload-demo"
              :with-credentials="true"
              multiple
              :limit="1"
              ref="uploadLargeCover"
              accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.tiff"
              :auto-upload="true"
              :headers="{ Authorization: token }"
              :show-file-list="true"
              :on-success="handleAvatarSuccessImgLarge"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>
          <el-form-item label="Quiz封面连接">
            <el-input v-model="addVideoForm.image" :disabled="true"></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitVideoForm('ruleForm')">确 定</el-button>
        </div>
      </el-dialog>




      <el-dialog
        :title="'添加Quiz内容: '+addVideoForm.title"
        :visible.sync="dialogFormVisible1"
        top="3vh"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <el-form
          :model="addVideoFormItem"
          class="search_parent"
          size="mini"
          top="0"
          label-width="120px"
        >
          <template>
            <div>
              <div
                v-for="(question, index) in addVideoFormItem.questions"
                :key="index"
                class="quiz_question_parent"
              >
                <el-form-item :label="`问题${index + 1}`" class="question_title">
                  <el-input
                    v-model="question.question"
                    :placeholder="`请输入问题${index + 1}`"
                  ></el-input>
                  <el-button class="add_btn" type="primary" v-if="index == 0" @click="addQuestion">+</el-button>
                  <el-button class="add_btn" type="primary" v-else @click="removeQuestion(index,question)">-</el-button>
                </el-form-item>
                <el-form-item :label="`问题${index + 1}图片`">
                  <el-upload
                    drag
                    action="https://adminapi.ci-ads.com/api/movie/upload/file"
                    style="display: inline-block; margin-left: 15px"
                    class="upload-demo"
                    :with-credentials="true"
                    multiple
                    :limit="1"
                    :ref="`uploadQuestionImage${index}`"
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.tiff"
                    :auto-upload="true"
                    :headers="{ Authorization: token }"
                    :show-file-list="false"
                    :on-success="
                      (response, file, fileList) =>
                        handleOptionImageSuccess(response, file, fileList, index)
                    "
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </el-form-item>
                <el-form-item :label="`问题${index + 1}图片连接`">
                  <el-input v-model="question.image" :disabled="true"></el-input>
                </el-form-item>
                <template>
                  <div class="options_parent">
                    <div
                      v-for="(option, optionIndex) in question.options"
                      :key="optionIndex"
                    >
                      <el-form-item :label="`选项${optionIndex + 1}`" class="question_title">
                        <el-input
                          v-model="option.name"
                          :placeholder="`请输入选项${optionIndex + 1}`"
                        ></el-input>
                        <el-button class="add_btn" type="primary" v-if="optionIndex == 0" @click="addOption(index, optionIndex)">+</el-button>
                        <el-button class="add_btn" type="primary" v-else @click="removeOption(index, optionIndex,option,question)">-</el-button>
                      </el-form-item>
                      <el-form-item :label="`选项${optionIndex + 1}排序`">
                        <el-input
                          v-model="option.optionNumber"
                          :placeholder="`请输入选项${optionIndex + 1}排序`"
                        ></el-input>
                      </el-form-item>
                      <el-form-item :label="`选项${optionIndex + 1}分数`">
                        <el-input
                          v-model="option.score"
                          :placeholder="`请输入选项${optionIndex + 1}分数`"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="addQuizQuestions">确 定</el-button>
        </div>
      </el-dialog>


      <el-dialog
        :title="'添加结果预设: '+addVideoForm.title"
        :visible.sync="dialogFormVisible2"
        top="5vh"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <el-form
          :model="addVideoResult"
          class="search_parent"
          size="mini"
          top="0"
          label-width="120px"
        >
          <template>
            <div v-for="(result, index) in addVideoResult.resultPreset" class="quiz_question_parent">
                <el-form-item :label="`预设标题${index + 1}`" class="question_title">
                  <el-input v-model="result.title" :placeholder="`请输入结果预设${index + 1}标题`"></el-input>

                  <el-button type="primary" @click="addResultPreset" v-if="index == 0">+</el-button>
                  <el-button type="primary" @click="removeResultPreset(index)" v-else>-</el-button>
                </el-form-item>
                <el-form-item label="最大分数">
                  <el-input v-model="result.maxScore" :placeholder="`请输入结果预设${index + 1}最大分数`"></el-input>
                </el-form-item>
                <el-form-item label="最小分数">
                  <el-input v-model="result.minScore" :placeholder="`请输入结果预设${index + 1}最大小分数`"></el-input>
                </el-form-item>
                <el-form-item label="预设结果答案">
                  <el-input v-model="result.result" :placeholder="`请输入结果预设${index + 1}预设结果答案`"></el-input>
                </el-form-item>
                <el-form-item label="结果预设图片">
                  <el-upload
                    drag
                    action="https://adminapi.ci-ads.com/api/movie/upload/file"
                    style="display: inline-block; margin-left: 15px"
                    class="upload-demo"
                    :with-credentials="true"
                    multiple
                    :limit="1"
                    :ref="`uploadResultImage${index}`"
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.tiff"
                    :auto-upload="true"
                    :headers="{ Authorization: token }"
                    :show-file-list="true"
                    :on-success="
                      (response, file, fileList) =>
                        handleResultImageSuccess(response, file, fileList, index)
                    "
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="结果图片连接">
                  <el-input v-model="result.image" :disabled="true"></el-input>
                </el-form-item>
            </div>
          </template>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="updateResultForm">确 定</el-button>
        </div>
      </el-dialog>



      <el-dialog
        title="更新Quiz内容"
        :visible.sync="dialogFormVisible3"
        top="3vh"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <el-form
          :model="addVideoForm"
          class="search_parent"
          size="mini"
          top="0"
          label-width="120px"
        >
        <el-form-item label="Quiz标题">
            <el-input
              v-model="addVideoForm.title"
              clearable
              placeholder="请输入Quiz标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="作者">
            <el-input
              v-model="addVideoForm.editor"
              clearable
              placeholder="请输入作者名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="Quiz概要">
            <el-input
              type="textarea"
              v-model="addVideoForm.description"
              clearable
              placeholder="请输入Quiz概要"
            ></el-input>
          </el-form-item>
          <el-form-item label="Quiz分类">
            <el-select v-model="addVideoForm.categoryId" @change="categoryChange">
              <el-option v-for="(item,index) in categoryList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传封面">
            <el-upload
              drag
              action="https://adminapi.ci-ads.com/api/movie/upload/file"
              style="display: inline-block; margin-left: 15px"
              class="upload-demo"
              :with-credentials="true"
              multiple
              :limit="1"
              ref="uploadLargeCover"
              accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.tiff"
              :auto-upload="true"
              :headers="{ Authorization: token }"
              :show-file-list="true"
              :on-success="handleAvatarSuccessImgLarge"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>
          <el-form-item label="Quiz封面连接">
            <el-input v-model="addVideoForm.image" :disabled="true"></el-input>
          </el-form-item>
          <template>
            <div>
              <div
                v-for="(question, index) in addVideoForm.questions"
                :key="index"
                class="quiz_question_parent"
              >
                <el-form-item :label="`问题${index + 1}`" class="question_title">
                  <el-input
                    v-model="question.question"
                    :placeholder="`请输入问题${index + 1}`"
                  ></el-input>
                  <el-button class="add_btn" type="primary" v-if="index == 0" @click="addQuestion">+</el-button>
                  <el-button class="add_btn" type="primary" v-else @click="removeQuestion(index,question)">-</el-button>
                </el-form-item>
                <el-form-item :label="`问题${index + 1}图片`">
                  <el-upload
                    drag
                    action="https://adminapi.ci-ads.com/api/movie/upload/file"
                    style="display: inline-block; margin-left: 15px"
                    class="upload-demo"
                    :with-credentials="true"
                    multiple
                    :limit="1"
                    :ref="`uploadQuestionImage${index}`"
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.tiff"
                    :auto-upload="true"
                    :headers="{ Authorization: token }"
                    :show-file-list="true"
                    :on-success="
                      (response, file, fileList) =>
                        handleOptionImageSuccess(response, file, fileList, index)
                    "
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </el-form-item>
                <el-form-item :label="`问题${index + 1}图片连接`">
                  <el-input v-model="question.image" :disabled="true"></el-input>
                </el-form-item>
                <template>
                  <div class="options_parent">
                    <div
                      v-for="(option, optionIndex) in question.options"
                      :key="optionIndex"
                    >
                      <el-form-item :label="`选项${optionIndex + 1}`" class="question_title">
                        <el-input
                          v-model="option.name"
                          :placeholder="`请输入选项${optionIndex + 1}`"
                        ></el-input>
                        <el-button class="add_btn" type="primary" v-if="optionIndex == 0" @click="addOption(index, optionIndex)">+</el-button>
                        <el-button class="add_btn" type="primary" v-else @click="removeOption(index, optionIndex,option,question)">-</el-button>
                      </el-form-item>
                      <el-form-item :label="`选项${optionIndex + 1}排序`">
                        <el-input
                          v-model="option.optionNumber"
                          :placeholder="`请输入选项${optionIndex + 1}排序`"
                        ></el-input>
                      </el-form-item>
                      <el-form-item :label="`选项${optionIndex + 1}分数`">
                        <el-input
                          v-model="option.score"
                          :placeholder="`请输入选项${optionIndex + 1}分数`"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <template>
            <div v-for="(result, index) in addVideoForm.resultPreset" class="quiz_question_parent">
                <el-form-item :label="`预设标题${index + 1}`" class="question_title">
                  <el-input v-model="result.title" :placeholder="`请输入结果预设${index + 1}标题`"></el-input>

                  <el-button type="primary" @click="addResultPreset" v-if="index == 0">+</el-button>
                  <el-button type="primary" @click="removeResultPreset(index)" v-else>-</el-button>
                </el-form-item>
                <el-form-item label="最大分数">
                  <el-input v-model="result.maxScore" :placeholder="`请输入结果预设${index + 1}最大分数`"></el-input>
                </el-form-item>
                <el-form-item label="最小分数">
                  <el-input v-model="result.minScore" :placeholder="`请输入结果预设${index + 1}最大小分数`"></el-input>
                </el-form-item>
                <el-form-item label="预设结果答案">
                  <el-input v-model="result.result" :placeholder="`请输入结果预设${index + 1}预设结果答案`"></el-input>
                </el-form-item>
                <el-form-item label="结果预设图片">
                  <el-upload
                    drag
                    action="https://adminapi.ci-ads.com/api/movie/upload/file"
                    style="display: inline-block; margin-left: 15px"
                    class="upload-demo"
                    :with-credentials="true"
                    multiple
                    :limit="1"
                    :ref="`uploadResultImage${index}`"
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.tiff"
                    :auto-upload="true"
                    :headers="{ Authorization: token }"
                    :show-file-list="true"
                    :on-success="
                      (response, file, fileList) =>
                        handleResultImageSuccess(response, file, fileList, index)
                    "
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="结果图片连接">
                  <el-input v-model="result.image" :disabled="true"></el-input>
                </el-form-item>
            </div>
          </template>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible3 = false">取 消</el-button>
          <el-button type="primary" @click="updateQuzi">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
// import episodeManager from "./episodeManager.vue";
export default {
  // components: { episodeManager },
  data() {
    return {
      videoId: 0,
      id:"",
      movieName: "",
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      total: 0,
      videoList: [],
      categoryList: [],
      videoSearch: {
        categoryId: "",
        currentPage: 1,
        enabled: "",
        endTime: "",
        hot: "",
        movieName: "",
        pageSize: 50,
        recommend: "",
        startTime: "",
        type: "Quiz",
        domain: "",
        vastLink: "",
      },
      dialogFormVisible: false,
      string: "添加",
      loading: false,
      addVideoForm: {
        description: "",
        categoryId:"",
        editor: "",
        image: "",
        questions: [
          {
            image: "",
            options: [
              {
                image: "",
                name: "",
                optionNumber: 1,
                score: 0,
              },
            ],
            question: "问题1",
          },
        ],
        resultPreset: [
          {
            image: "",
            maxScore: 0,
            minScore: 0,
            result: "",
            title: "",
          },
        ],
        title: "",
      },
      edit: false,
      addEpisodeForm: {
        episode: "",
        episodeName: "",
        fileExt: "",
        image: "",
        movieId: "",
        needAd: "",
        needPay: "",
        payPrice: "",
        size: "",
        summary: "",
        url: "",
      },
      fileList: [],
      fileList1: [],
      fileList2: [],
      token: JSON.parse(sessionStorage.getItem("loginData")).token,
      multipleSelection: [],
      domainList: [],
      domain: "",
      title: "添加Quiz",
      addVideoFormItem:{
        questions: [
          {
            image: "",
            options: [
              {
                image: "",
                name: "",
                optionNumber: 1,
                score: 0,
              },
            ],
            question: "",
          },
        ]
      },
      addVideoResult:{
        resultPreset: [
          {
            image: "",
            maxScore: 0,
            minScore: 0,
            result: "",
            title: "",
          },
        ]
      }
    };
  },
  methods: {
    categoryChange(val){
      console.log(val);
    },
    updateQuzi(){
      axiosPost("/api/quiz/add", this.addVideoForm, "JSON").then((res) => {
            if (res.code == 0) {
              this.dialogFormVisible3 = false;
              this.$message({ message: "quiz更新成功", type: "success" });
            }
          })
    },
  async getQuizDetail(id){
      let obj={};
      await axiosGet("/api/quiz/info?id="+id).then((res) => {
        if(res.code==0){
          obj=res.data;
        }
      });
      return obj;
    },
   async openAddResultDialog(row){
      this.getQuizDetail(row.id).then(obj=>{
        this.dialogFormVisible2 = true;
        this.addVideoForm.id=obj.id;
        this.addVideoForm.title=obj.title;
        this.addVideoForm.description=obj.description;
        this.addVideoForm.editor=obj.editor;
        this.addVideoForm.image=obj.image;
        this.addVideoForm.categoryId=obj.categoryId;
        let preset;
        if(!obj.preset){
          preset = [
              {
              image: "",
              maxScore: 0,
              minScore: 0,
              result: "",
              title: "",
            }
          ]
        }
        this.addVideoResult.resultPreset = obj.preset?obj.preset:preset;
      });
    },
    updateResultForm(){
      // 判断所有字段是否均不为空
      const isFormValid = Object.keys(this.addVideoResult).every(key => {
          const value = this.addVideoResult[key];
          return value !== null && value !== undefined && value !== '';
        });
        if (!isFormValid) {
          this.$message({ message: "请填写所有必填项", type: "error" });
          return false;
        }else{
          delete this.addVideoForm.questions;
          this.addVideoForm.resultPreset = this.addVideoResult.resultPreset;
          axiosPost("/api/quiz/add", this.addVideoForm, "JSON").then((res) => {
            if (res.code == 0) {
              this.dialogFormVisible2 = false;
              this.$message({ message: "添加成功", type: "success" });
            }
          })
        }
    },
    openAddQuestionDialog(row){

      this.getQuizDetail(row.id).then(obj=>{
        this.dialogFormVisible1 = true;
        this.addVideoForm.id=row.id;
        this.addVideoForm.title=row.title;
        this.addVideoForm.description=row.description;
        this.addVideoForm.editor=row.editor;
        this.addVideoForm.image=row.image;
        this.addVideoForm.categoryId=row.categoryId;
        let questions;
        if(!obj.questions.length){
          questions = [
            {
              image: "",
              options: [
                {
                  image: "",
                  name: "",
                  optionNumber: 1,
                  score: 0,
                },
              ],
              question: "问题1",
            },
          ]
        }
        this.addVideoFormItem.questions = obj.questions.length?obj.questions:questions;
      });
      // console.log(row)
      // this.addVideoFormItem.questions = row.questions;
    },
    addQuizQuestions(){
        // 判断所有字段是否均不为空
        const isFormValid = Object.keys(this.addVideoFormItem).every(key => {
          const value = this.addVideoFormItem[key];
          return value !== null && value !== undefined && value !== '';
        });
        if (!isFormValid) {
          this.$message({ message: "请填写所有必填项", type: "error" });
          return false;
        }else{
          this.addVideoForm.questions = this.addVideoFormItem.questions;
          delete this.addVideoForm.resultPreset;
          console.log( this.addVideoForm);
          axiosPost("/api/quiz/add", this.addVideoForm, "JSON").then((res) => {
            if (res.code == 0) {
              this.dialogFormVisible1 = false;
              this.$message({ message: "添加成功", type: "success" });
            }
          })
        }
      },
    addResultPreset(){
      this.addVideoResult.resultPreset.push({
        image: "",
        maxScore: 0,
        minScore: 0,
        result: "",
        title: "",
      })
    },
    removeResultPreset(index){
      this.addVideoResult.resultPreset.splice(index,1);
    },
    handleResultImageSuccess(response, file, fileList, index){
      if(this.dialogFormVisible2){
        this.addVideoResult.resultPreset[index].image = response.data.url;
      }else{
        this.addVideoForm.resultPreset[index].image = response.data.url;
      }
    },
    removeOption(index, optionIndex,option,question) {
      if(this.addVideoForm.id){
        this.$confirm("是否要删除该选项?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(()=>{
          if(question.id){
            axiosPost('/api/quiz/option/delete',{optionNumbers:[option.optionNumber],questionId:question.id},'JSON').then(res=>{
              if(res.code==0){
                this.addVideoFormItem.questions[index].options.splice(optionIndex,1);
                this.$message({ message: "删除成功", type: "success" });
                this.addVideoFormItem.questions[index].options.splice(optionIndex,1);
              }
            })
          }else{
            this.addVideoFormItem.questions[index].options.splice(optionIndex,1);
          }

        }).catch(()=>{});
      }else{
        this.addVideoFormItem.questions[index].options.splice(optionIndex,1);
      }

    },
    addOption(index, optionIndex){
      this.addVideoFormItem.questions[index].options.push({
        image: "",
        name: "",
        optionNumber: this.addVideoFormItem.questions[index].options.length + 1,
        score:0
      })
    },
    removeQuestion(index,question){
      if(this.addVideoForm.id){
        this.$confirm("是否要删除该问题?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(()=>{
          if(question.id){
              axiosPost('/api/quiz/question/delete',{ids:[question.id]},'JSON').then(res=>{
              if(res.code==0){
                this.addVideoFormItem.questions.splice(index,1);
                this.$message({ message: "删除成功", type: "success" });
              }
            })
          }else{
            this.addVideoFormItem.questions.splice(index,1);
          }

        }).catch(()=>{});
      }else{
        this.addVideoFormItem.questions.splice(index,1);
      }


    },
    addQuestion(){
      this.addVideoFormItem.questions.push({
            image: "",
            options: [
              {
                image: "",
                name: "",
                optionNumber: 1,
                score: 0,
              },
            ],
            question: "",
          })
    },
    handleOptionImageSuccess(response, file, fileList, index) {
      // 假设上传成功后，服务器返回的图片路径在 response.url 中
      if(this.dialogFormVisible1){
        this.addVideoFormItem.questions[index].image = response.data.url;
      }else{
        this.addVideoForm.questions[index].image = response.data.url;
      }

    },
    async addMovieToDm() {
      if (!this.domain) {
        this.$message({ message: "请先选择域名", type: "error" });
        return false;
      }
      if (!this.multipleSelection.length) {
        this.$message({ message: "请至少选择一个Quiz", type: "error" });
        console.log(this.multipleSelection);
        return false;
      } else {
        this.loading = true;
        let movieIds = [];
        this.multipleSelection.forEach((item) => {
          movieIds.push(item.id);
        });
        await axiosPost(
          "/api/quiz/add_domain",
          { domain: this.domain, quizId: movieIds.join(",") },
          "JSON"
        ).then((res) => {
          if (res.code == 0) {
            movieIds = [];
            this.$refs.multipleTable.clearSelection();
          }
        });
        await axiosPost(
          "/api/quiz/make_json",
          { domain: this.domain, lang: "en" },
          "JSON"
        ).then((res) => {
          if (res.code == 0) {
            movieIds = [];
            this.$refs.multipleTable.clearSelection();
            // this.$message({message:"Quiz加入域名成功,JSON文件生成成功",type:"success"});
          }
        });
        await axiosPost(
          '/api/quiz/make_category_json',
          { domain: this.domain},
          'JSON'
        ).then((res) => {
          if (res.code == 0) {

          }
        });
        this.$message({message:"Quiz加入域名成功,JSON文件生成成功",type:"success"});
        this.domain = "";
        this.loading = false;
      }
    },
    removeMovieToDm() {
      if (!this.domain) {
        this.$message({ message: "请先选择域名", type: "error" });
        return false;
      }
      if (!this.multipleSelection.length) {
        this.$message({ message: "请至少选择一个Quiz", type: "error" });
        return false;
      } else {
        let movieIds = [];
        this.multipleSelection.forEach((item) => {
          movieIds.push(item.id);
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleAvatarSuccessImgLarge(res) {
      if (res.code == 0) {
        this.addVideoForm.image = res.data.url;
        console.log(res.data.url);
        this.$forceUpdate(); // 强制更新页面上的表单内容
        this.$refs.uploadLargeCover.clearFiles();
      }
    },
    async getDomainList() {
      await axiosGet("/api/domains/list", {
        currentPage: 1,
        pageSize: 50,
        dmType: 2,
      }).then((res) => {
        if (res.code == 0) {
          this.domainList = res.data.records;
        }
      });
    },
    async getList(params) {
      this.loading = true;
      let copyParams = {
        categoryId: "",
        currentPage: params.currentPage || 1,
        enabled: "",
        endTime: "",
        hot: "",
        movieName: "",
        pageSize: params.pageSize || 50,
        recommend: "",
        startTime: "",
        type: "Quiz",
        domain: "",
        vastLink: "",
      };
      await axiosGet("/api/quiz/list", copyParams).then((res) => {
        if (res.code == 0) {
          this.videoList = res.data.records;
          this.total = res.data.total;
        }
      });
      if (params.domain) {
        await axiosGet("/api/quiz/list", params).then((result) => {
          if (result.code == 0) {
            if (result.data.records) {
              result.data.records.forEach((item) => {
                const matchedRow = this.videoList.find((row) => row.id === item.id);
                if (matchedRow) {
                  this.$refs.multipleTable.toggleRowSelection(matchedRow, true);
                }
              });
            }
          }
        });
      }
      this.loading = false;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    },
    checkEpisodeForThis(row) {
      this.videoId = row.id;
      this.movieName = row.movieName;
      this.dialogFormVisible1 = true;
    },
    deleteVideo(row) {
      this.$confirm("是否要删除 " + row.movieName + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axiosPost("/api/movie/delete", { id: row.id }, "JSON").then((res) => {
            if (res.code == 0) {
              this.getList(this.videoSearch);
              this.$message({ message: "删除成功", type: "success" });
            }
          });
        })
        .catch(() => {});
    },
    addVideo() {
      this.edit = false;
      this.string = "添加";
      this.addVideoForm = {
        description: "",
        editor: "",
        image: "",
        categoryId:1,
        title: "",
      };
      this.dialogFormVisible = true;
    },
    deleteQuiz(row){
      this.$confirm("是否要删除 " + row.title + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        axiosPost("/api/quiz/delete", { ids: [row.id] }, "JSON").then((res) => {
          if(res.code==0){
            this.getList(this.videoSearch);
            this.$message({ message: "删除成功", type: "success" });
          }
        });
      }).catch(() => {});
    },
    updateVideo(row) {
      this.getQuizDetail(row.id).then(obj=>{
        this.dialogFormVisible3 = true;
        this.addVideoForm.id=row.id;
        this.addVideoForm.title=obj.title;
        this.addVideoForm.description=obj.description;
        this.addVideoForm.editor=obj.editor;
        this.addVideoForm.image=obj.image;
        this.addVideoForm.categoryId=obj.categoryId;
        let questions;
        if(!obj.questions.length){
          questions = [
            {
              image: "",
              options: [
                {
                  image: "",
                  name: "",
                  optionNumber: 1,
                  score: 0,
                },
              ],
              question: "问题1",
            },
          ]
        }
        this.addVideoForm.questions = obj.questions?obj.questions:questions;
        let preset;
        if(!obj.preset){
          preset = [
              {
              image: "",
              maxScore: 0,
              minScore: 0,
              result: "",
              title: "",
            }
          ]
        }
        this.addVideoForm.resultPreset = obj.preset?obj.preset:preset;
      });
    },
    getCategoryList() {
      this.loading = true;
      axiosGet("/api/quiz/category/list").then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.categoryList = res.data;
          }

          this.loading = false;
        }
      });
    },
    async submitVideoForm(formName) {
      let url = "/api/quiz/add";
       // 判断所有字段是否均不为空
      delete this.addVideoForm.resultPreset;
      delete this.addVideoForm.questions;
      axiosPost(url, this.addVideoForm, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: "Quiz" + this.string + "成功", type: "success" });
            this.dialogFormVisible = false;
            this.getList(this.videoSearch);
          }
        });

    },
    handleSizeChange(val) {
      this.videoSearch.pageSize = val;
      this.getList(this.videoSearch);
    },
    handleCurrentChange(val) {
      this.videoSearch.currentPage = val;
      this.getList(this.videoSearch);
    },
    addMovieToDomain(row) {
      // axiosPost('/api/movie/add_domain',{domain:"",})
    },
    shareHtml(row) {
      if (!this.domain) {
        this.$message({ message: "请先选择域名", type: "error" });
      } else {
        this.$alert(`https://${this.domain}/video.html?id=${row.id}`, "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      }
    },
    domainChange(val) {
      this.videoSearch.domain = val;
      this.getList(this.videoSearch);
    },
    getCategoryName(id) {
      let categoryName = "";
      this.categoryList.forEach((item) => {
        if (item.id == id) {
          categoryName = item.name;
        }
      });
      return categoryName;
    }
  },
  mounted() {
    this.getCategoryList();
    this.domain = sessionStorage.getItem("needDm") || "";
    this.videoSearch.domain = this.domain;
    this.getList(this.videoSearch);
    this.getDomainList();
  },
  destroyed() {
    sessionStorage.removeItem("needDm");
  },
};
</script>


<style>
  .question_title .el-form-item__content{
    display: flex;
    justify-content: space-between;
  }
  .options_parent{
    width:80%;
  }
  .quiz_question_parent{
    margin-bottom:15px;
    border-bottom:1px dashed #ccc;
  }
  .el-message{
    z-index: 10000;
  }
  .img_demo{
    width:200px;
    height:100px;
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/QuizManager/index.vue